import { useEffect } from "react";
import { EuiPopover } from "@elastic/eui";

interface PopoverProps {
  isOpen: boolean;
  onClose: () => void;
  onKeyDown?: (e: any) => void;
  button: any;
  children: any;
  className?: any;
  ownFocus?: boolean;
  anchorPosition?:
    | "upCenter"
    | "upLeft"
    | "upRight"
    | "downCenter"
    | "downLeft"
    | "downRight"
    | "leftCenter"
    | "leftUp"
    | "leftDown"
    | "rightCenter"
    | "rightUp"
    | "rightDown"
    | undefined;
  style?: any;
  panelStyle?: any;
  panelPaddingSize?: "none" | "xs" | "s" | "m" | "l" | "xl" | undefined;
  noCloseOnScroll?: boolean;
  repositionOnScroll?: boolean;
  offset?: number;
}

const Popover = ({
  isOpen,
  onClose,
  onKeyDown = (e: any) => {},
  button,
  children,
  className,
  ownFocus = false,
  anchorPosition,
  style,
  panelStyle,
  panelPaddingSize,
  noCloseOnScroll = false,
  repositionOnScroll = true,
  offset = 4,
}: PopoverProps) => {
  useEffect(() => {
    if (noCloseOnScroll) return;
    window.removeEventListener("scroll", onClose);
    window.addEventListener("scroll", onClose, { passive: true });
    return () => window.removeEventListener("scroll", onClose);
  }, []);

  return (
    <EuiPopover
      repositionOnScroll={repositionOnScroll}
      repositionToCrossAxis
      button={button}
      onKeyDown={onKeyDown}
      closePopover={onClose}
      isOpen={isOpen}
      ownFocus={ownFocus}
      className={className}
      anchorPosition={anchorPosition}
      style={style}
      offset={offset}
      buffer={[16, 16, 16, 8]}
      panelStyle={{
        backgroundColor: "var(--card-background)",
        borderRadius: "var(--box-radius) !important",
        ...panelStyle,
      }}
      panelProps={{
        onMouseDownCapture: (e) => {
          e.stopPropagation();
        },
      }}
      panelPaddingSize={panelPaddingSize || "none"}>
      {children}
    </EuiPopover>
  );
};

export default Popover;
